import type * as Immutable from 'immutable';
import { createMigration } from './utils';

const FANCY_CAPTION_CLASS_TYPE = 'CanvasFancyCaptionAsset';

const EMPTY_SPOKEN_WORD_STYLE = {
    fontUrl: 'https://storage.googleapis.com/lumen5-site-css/Poppins-SemiBold.ttf',
    fill: 0xffffff,
    renderHighlighted: false,
    renderHighlightedColor: false,
    shadow: true,
    shadowAngle: 1,
    shadowBlur: 10,
    shadowAlpha: 0.5,
    shadowColor: 0,
    shadowDistance: 2,
    animationConfigurations: [],
    graphics: [],
    textDirection: 'ltr',
};

export const migrationTo9_236 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            map.get('sceneGroups', []).forEach(
                (sceneGroup: Immutable.Map<string, unknown>, i: number) => {
                    map.setIn(['sceneGroups', i], this.migrateSceneGroup(sceneGroup));
                },
            );
            map.get('slides').forEach((scene: Immutable.Map<string, unknown>, i: number) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateSceneGroup(sceneGroup) {
        return sceneGroup.withMutations((map) => {
            const captionAsset = map.getIn(['captions', 'asset']) as
                | Immutable.Map<string, unknown>
                | undefined;
            if (!captionAsset) {
                return;
            }

            const classType = captionAsset.get('classType') as string;
            const basePath = ['captions', 'asset'];

            if (classType !== FANCY_CAPTION_CLASS_TYPE || !captionAsset.has('spokenWordStyle')) {
                return;
            }
            map.setIn([...basePath, 'spokenWordStyle'], EMPTY_SPOKEN_WORD_STYLE);
            map.setIn([...basePath, 'isSpokenWordStyleEnabled'], false);
        });
    },
    migrateScene(scene) {
        return scene.withMutations((map) => {
            map.get('children', []).forEach(
                (child: Immutable.Map<string, unknown>, cIndex: number) => {
                    const path = ['children', cIndex];
                    const asset = map.getIn(path) as Immutable.Map<string, unknown> | undefined;
                    if (!asset) {
                        return;
                    }

                    const classType = asset.get('classType') as string;

                    if (classType !== FANCY_CAPTION_CLASS_TYPE || !asset.has('spokenWordStyle')) {
                        return;
                    }
                    map.setIn([...path, 'spokenWordStyle'], EMPTY_SPOKEN_WORD_STYLE);
                    map.setIn([...path, 'isSpokenWordStyleEnabled'], false);
                },
            );

            const textPositionPresets = map.get('textPositionPresets') as
                | Immutable.Map<string, Immutable.List<Immutable.Map<string, unknown>>>
                | undefined;
            if (!textPositionPresets) {
                return;
            }
            textPositionPresets.forEach(
                (
                    presetAssets: Immutable.List<Immutable.Map<string, unknown>>,
                    position: string,
                ) => {
                    if (!presetAssets) {
                        return;
                    }
                    presetAssets.forEach(
                        (asset: Immutable.Map<string, unknown>, aIndex: number) => {
                            const path = ['textPositionPresets', position, aIndex];
                            if (!asset) {
                                return;
                            }

                            const classType = asset.get('classType') as string;

                            if (
                                classType !== FANCY_CAPTION_CLASS_TYPE ||
                                !asset.has('spokenWordStyle')
                            ) {
                                return;
                            }
                            map.setIn([...path, 'spokenWordStyle'], EMPTY_SPOKEN_WORD_STYLE);
                            map.setIn([...path, 'isSpokenWordStyleEnabled'], false);
                        },
                    );
                },
            );
        });
    },
});
